import { Theme, Typography } from '@mui/material';
import { TypographyLink } from '@/components/common/TypographyLink';
import { config } from '@/app/config';
import React, { FC, ReactElement } from 'react';

export const ForeignNumberNotice: FC = (): ReactElement => {
  const handleClick = (): void => {
    window.open(config.links.prisonmail, '_blank', 'noopener,noreferrer');
  };

  return (
    <Typography variant={'body2'} sx={{ color: (theme: Theme) => theme.colors.grayText }}>
      {'Принимаются только номера РФ (+7). Для иностранных номеров используйте сервис '}
      <TypographyLink onClick={handleClick} data-testid={'prisonmail-link'}>
        {'Prison Mail'}
      </TypographyLink>
    </Typography>
  );
};
